import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageSquare, Navigation } from "lucide-react";

const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-background px-6 pb-10 pt-20 md:px-12">
    <div className="mx-auto max-w-[1500px]">
      <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-16 md:grid-cols-12">
        <div className="md:col-span-6">
          <h2 className="font-cabinet text-5xl font-black uppercase leading-none tracking-tighter md:text-7xl">
            <span className="gradient-text">Let's Make It Immaculate</span>
          </h2>
          <button
            data-testid="footer-cta"
            onClick={() => scrollTo("#booking")}
            className="mt-8 gradient-fill px-8 py-4 font-mono-x text-xs uppercase tracking-widest text-black transition-opacity duration-300 hover:opacity-90"
          >
            Book Your Detail
          </button>
        </div>

        <div className="md:col-span-3">
          <span className="font-mono-x text-[11px] uppercase tracking-widest text-primary">Contact</span>
          <ul className="mt-6 space-y-4 text-sm text-zinc-400">
            <li>
              <a href="tel:+18125834516" data-testid="footer-call" className="flex items-center gap-3 transition-colors duration-300 hover:text-primary">
                <Phone size={15} className="text-primary" /> (812) 583-4516
              </a>
            </li>
            <li>
              <a href="sms:+18125834516" data-testid="footer-text" className="flex items-center gap-3 transition-colors duration-300 hover:text-primary">
                <MessageSquare size={15} className="text-primary" /> Text us
              </a>
            </li>
            <li>
              <a href="mailto:velocitydetail26@gmail.com" data-testid="footer-email" className="flex items-center gap-3 break-all transition-colors duration-300 hover:text-primary">
                <Mail size={15} className="shrink-0 text-primary" /> velocitydetail26@gmail.com
              </a>
            </li>
            <li>
              <a href="https://maps.google.com/?q=1+Water+St,+Williams,+IN+47470" target="_blank" rel="noreferrer" data-testid="footer-map" className="flex items-start gap-3 transition-colors duration-300 hover:text-primary">
                <MapPin size={15} className="mt-0.5 shrink-0 text-primary" /> 1 Water St, Williams, IN 47470
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <span className="font-mono-x text-[11px] uppercase tracking-widest text-primary">Hours</span>
          <ul className="mt-6 space-y-4 text-sm text-zinc-400">
            <li className="flex justify-between border-b border-white/5 pb-2"><span>Mon – Sat</span><span className="text-white">8AM – 8PM</span></li>
            <li className="flex items-center gap-2 pt-1 font-mono-x text-[11px] uppercase tracking-widest text-primary"><span className="h-1.5 w-1.5 bg-primary" /> 100% Mobile — We Come To You</li>
          </ul>
          <div className="mt-6">
            <span className="font-mono-x text-[11px] uppercase tracking-widest text-primary">Service Area</span>
            <p className="mt-3 flex items-start gap-3 text-sm text-zinc-400">
              <Navigation size={15} className="mt-0.5 shrink-0 text-primary" />
              Williams, Bedford, Mitchell, Oolitic, Springville, Orleans, Paoli, Bloomington, French Lick & nearby. Outside the area? Give us a call.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-6 pt-8 md:flex-row">
        <div className="flex items-center gap-2.5">
          <span className="h-2.5 w-2.5 rotate-45 bg-primary" />
          <span className="font-cabinet text-lg font-black uppercase tracking-tight text-white">Velocity<span className="text-primary">.</span></span>
        </div>
        <p className="font-mono-x text-[11px] uppercase tracking-widest text-zinc-400">© {new Date().getFullYear()} Velocity Detailing Co. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/login" data-testid="owner-login-link" className="font-mono-x text-[11px] uppercase tracking-widest text-zinc-400 transition-colors duration-300 hover:text-primary">Owner Login</Link>
        </div>
      </div>
    </div>
  </footer>
);
